module.exports = __webpack_public_path__ + "static/media/1.fbab0fb3.PNG";